import { SearchPageContainer as SearchPage } from './SearchPageContainer';

export { SearchPage };
export default SearchPage;
